import React from "react";
import { useEffect, useContext } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Callback from "../Auth/Callback";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import { ToastContainer } from "react-toastify";
import AdminContext from "../Helper/admin";
import PasswordReset from "../Auth/PasswordReset";
// require('dotenv').config()

// setup fake backend
const Routers = () => {
  const { isAuthenticated } = useContext(AdminContext);

  useEffect(() => {
    let abortController = new AbortController();
    // if (!studentDetails) {
    //   console.log("load data");
    //   fetchStudentDetails();
    // }
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <>
      <BrowserRouter basename={"/"}>
        <>
          <Routes>
            <Route path={"/"} element={<PrivateRoute />}>
              {isAuthenticated ? (
                <>
                  <Route
                    exact
                    path={``}
                    element={
                      <Navigate
                        to={`/dashboard`}
                      />
                    }
                  />
                  <Route
                    exact
                    path={`/`}
                    element={
                      <Navigate
                        to={`/dashboard`}
                      />
                    }
                  />
                </>
              ) : (
                ""
              )}
              <Route path={`/*`} element={<LayoutRoutes />} />
            </Route>
            <Route
              path={`/callback`}
              render={() => <Callback />}
            />

            <Route
              exact
              path={`/login`}
              element={<Signin />}
            />
            <Route
              path={`/email-handler`}
              element={<PasswordReset />}
            />
            {authRoutes.map(({ path, Components }, i) => (
              <Route path={path} element={Components} key={i} />
            ))}

          </Routes>
        </>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
};

export default Routers;